
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channel/[...slug]",
      function () {
        return require("private-next-pages/channel/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channel/[...slug]"])
      });
    }
  